
import React, { useState, useEffect } from "react";
import FilmForm from "./components/filmForm";
import FilmList from "./components/filmList";
import "bootstrap/dist/css/bootstrap.min.css";

const defaultFilms = [
  {
    id: 1,
    ad: "Star Wars 1",
    tur: "Bilim Kurgu",
    tarih: "2026 ocak",
    puan: 5,
    not: "Efsane"
  },
  {
    id: 2,
    ad: "Star Wars 2",
    tur: "Bilim Kurgu",
    tarih: "2026 ocak",
    puan: 5,
    not: "Efsane"
  },
  {
    id: 3,
    ad: "Star Wars 3",
    tur: "Bilim Kurgu",
    tarih: "2026 ocak",
    puan: 5,
    not: "Efsane"
  }
];


function App() {

  // 💾 localStorage varsa onu al, yoksa defaultFilms kullan
  const [films, setFilms] = useState(() => {
    const saved = localStorage.getItem("films");
    return saved ? JSON.parse(saved) : defaultFilms;
  });

  const [editingFilm, setEditingFilm] = useState(null);

  // 💾 Films değişince localStorage’a kaydet
  useEffect(() => {
    localStorage.setItem("films", JSON.stringify(films));
  }, [films]);

  

  // ➕ ➕ Güncelle veya Ekle
  const saveFilm = (film) => {

    if (editingFilm) {
      setFilms(
        films.map((f) =>
          f.id === editingFilm.id
            ? { ...film, id: editingFilm.id }
            : f
        )
      );
      setEditingFilm(null);

    } else {
      setFilms([
        ...films,
        {
          ...film,
          id: Date.now()
        }
      ]);
    }
  };

  // ❌ Sil
  const deleteFilm = (id) => {
    setFilms(films.filter((f) => f.id !== id));
  };

  // ✏ Düzenleme başlat
  const editFilm = (film) => {
    setEditingFilm(film);
  };

  return (
    
    
    <div className="container mt-5">

      <h1 className="text-center mb-5 fw-bold text-primary">
        🎬 Film İzleme Listesi
      </h1>

<div className="row justify-content-center mb-15">
  <div className="col-lg-8 col-md-15">
      <FilmForm
        onSave={saveFilm}
        editingFilm={editingFilm}
      />
      </div>
</div>
      <div className="row justify-content-center">
         <div className="col-lg-8">
      <FilmList
        films={films}
        onDelete={deleteFilm}
        onEdit={editFilm}
      />
      </div>
</div>
    </div>
  );
}

export default App;
